import { css } from '@appd/uik';

// todo: migrate to DataTable and delete this on removing Datagrid
export const DataGridMultilineCellRenderer = (props = { value: '—' }): JSX.Element => {
  const STYLES = {
    Container: css.Styles({
      fontSize: '13px',
      lineHeight: '20px',
      padding: '0px 0px 0px 8px',
      wordWrap: 'break-word',
      whiteSpace: 'normal',
      marginTop: '4px',
      marginBottom: '4px',
    }),
  };
  return <div style={STYLES.Container}>{props.value}</div>;
};
